// extracted by mini-css-extract-plugin
export default {"-large":"yHFFJ6bP1F4vqa4sbzaU","slider":"x1ZqJsMZfmSeU6xTWqKV","inputContainer":"yo9WMFtW4VYoRfo1Kp9o","duration":"zqRFklUKSCGRdUhr8mcx"};